import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import CarView from "../views/Car.vue";
import Inventory from "../views/Inventory.vue";
import Lease from "../views/Lease.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { title: "Home - Your Car LLC" },
  },
  {
    path: "/cars/:id",
    name: "car",
    component: CarView,
    props: true,
    meta: { title: "Car Details - Your Car LLC" },
  },
  {
    path: "/lease",
    name: "lease",
    component: Lease,
    meta: { title: "Lease - Your Car LLC" },
  },
  {
    path: "/buy",
    name: "buy",
    component: Inventory,
    meta: { title: "Inventory - Your Car LLC" },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Если есть хэш в URL (например, /#about)
    if (to.hash) {
      return {
        el: to.hash, // Прокрутка к элементу с указанным id
        behavior: "smooth", // Плавная прокрутка
      };
    }
    // Если есть сохраненная позиция (например, при возврате назад)
    if (savedPosition) {
      return savedPosition;
    }
    // По умолчанию прокрутка к началу страницы
    return { top: 0 };
  },
});

// Динамическое обновление заголовка страницы
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Your Car LLC";
  next();
});

export default router;
